module.exports = __webpack_public_path__ + "static/media/Desktop-inbox-2.9bbe38db.jpg";